import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="radio-toggle"
export default class extends Controller {
  static targets = [ "yes", "no", "detail" ]

  connect() {
    if (this.noTarget.checked && !this.detailTarget.classList.contains("hidden")) {
      this.detailTarget.classList.add("hidden")
    }

    if (this.yesTarget.checked && this.detailTarget.classList.contains("hidden")) {
      this.detailTarget.classList.remove("hidden")
    }
  }

  toggle(e) {
    switch (e.target.value) {
      case "true":
        this.detailTarget.classList.remove("hidden")
        break;
      case "false":
        this.detailTarget.classList.add("hidden")
        break;
      default:
        console.warn("Unexpected value", e.target.value)
    }
  }
}
